import { AxiosResponse } from 'axios';
import { ActionLogPersonalDetailsPayload } from '@/shared/services/actionLog/ActionLogPersonalDetailsPayload';
import { authService } from '@/shared/services';
import { ActionLog } from '@/shared/services/actionLog/ActionLogEntry';
import { HttpClientFactory } from '@/shared/services/HttpClientFactory';

const ACTION_LOG_URL = '/api/v1/access/action-log';

export const logAction = (evt: ActionLog): Promise<any> => HttpClientFactory.baseClientSilent
  .post(`${ACTION_LOG_URL}/${authService.getSessionId()}`, evt)
  .then((res: AxiosResponse) => res.data);

/**
 * Transform PersonalDetails State into an array of Log Payload
 *
 * @param personalDetailsData
 * @param nodesMap
 * @param initialPersonalDetails
 */
export function formatPersonalDetailsForLog(personalDetailsData: any, nodesMap: any, initialPersonalDetails: any): ActionLogPersonalDetailsPayload[] {
  return Object.entries(personalDetailsData)
    .filter(([key, value]) => {
      if (key === 'personal_details_dob') {
        return value !== Date.parse(initialPersonalDetails[key]);
      }

      return value !== initialPersonalDetails[key];
    })
    .map((([key, value]) => ({
      key,
      fieldTranslationToken: nodesMap[key]?.fieldTranslationToken,
      fieldTranslation: nodesMap[key]?.fieldTranslation,
      value,
    })));
}
